import { render, staticRenderFns } from "./ReputationView.vue?vue&type=template&id=2743f9ce&scoped=true"
import script from "./ReputationView.vue?vue&type=script&lang=js"
export * from "./ReputationView.vue?vue&type=script&lang=js"
import style0 from "./ReputationView.vue?vue&type=style&index=0&id=2743f9ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743f9ce",
  null
  
)

export default component.exports